import { MainPro, ProgressContainer, TitlePro } from "pages/home/components/Layout";

export const BoxTitle = ({ filteredSuggests, filteredInquiries }) => {
  return (
    <ProgressContainer $width={105} $height={315} $background="#0B589A">
      <TitlePro $top={56}>건의</TitlePro>
      <MainPro $top={5}>{filteredSuggests?.length}건</MainPro>
      <TitlePro $top={82}>문의</TitlePro>
      <MainPro $top={5}>{filteredInquiries?.length}건</MainPro>
    </ProgressContainer>
  );
};
